import React from 'react';
import { mockData } from '../mock';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQ = () => {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <span className="inline-block px-6 py-2 bg-[#F5F3ED] rounded-full text-[#1A3A2E] text-sm font-medium mb-6">
            FAQs
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A3A2E] mb-4">
            Antworten auf Ihre Fragen
          </h2>
          <p className="text-lg text-[#1A3A2E]/70 max-w-4xl mx-auto">
            Finden Sie Antworten zu den am häufigsten gestellten Fragen.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {mockData.faqs.map((faq, idx) => (
              <AccordionItem
                key={idx}
                value={`item-${idx}`}
                className="border-none shadow-lg rounded-lg px-6 bg-[#F5F3ED]"
              >
                <AccordionTrigger className="text-left text-xl font-bold text-[#1A3A2E] hover:text-[#2D4A3E] py-6">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-[#1A3A2E]/70 leading-relaxed pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;